import { useEffect, useState } from 'react';

import { getScreenSize, type ScreenSize } from '../../lib/responsivity.utils';

export function useScreenSize(): ScreenSize {
    const [ screenSize, setScreenSize ] = useState<ScreenSize>(getScreenSize());

    useEffect(() => {
        const handleResize = () => {
            const newScreenSize = getScreenSize();
            
            if (newScreenSize !== screenSize) {
                setScreenSize(newScreenSize);
            }
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [ screenSize ]);

    return screenSize;
}
